/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type KillswitchUserBadge = {
  affected: boolean;
  affectedNow: boolean;
  scheduled: boolean;
  userId: string;
};

/** @internal */
export const KillswitchUserBadge$inboundSchema: z.ZodMiniType<
  KillswitchUserBadge,
  unknown
> = z.pipe(
  z.object({
    affected: z.boolean(),
    affected_now: z.boolean(),
    scheduled: z.boolean(),
    user_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "affected_now": "affectedNow",
      "user_id": "userId",
    });
  }),
);

export function killswitchUserBadgeFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchUserBadge, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchUserBadge$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchUserBadge' from JSON`,
  );
}
